import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const Star: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#666' }) => {
  return (
    /*@ts-ignore*/
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
      <path
        fill={fill}
        fill-rule="evenodd"
        d="M5.085 14.207c-.544.283-1.217.076-1.503-.463-.113-.215-.153-.46-.111-.7l.556-3.213L1.67 7.554c-.44-.425-.449-1.122-.02-1.558.171-.174.395-.287.637-.322l3.259-.469 1.457-2.924c.272-.546.94-.77 1.49-.5.22.107.398.283.506.5l1.457 2.924 3.259.47c.608.087 1.03.646.94 1.249-.034.24-.148.461-.324.63l-2.357 2.277.556 3.213c.104.6-.303 1.17-.909 1.273-.24.041-.489.002-.706-.11L8 12.688l-2.915 1.518zm2.397-2.909c.324-.168.712-.168 1.036 0l2.421 1.261-.462-2.67c-.062-.358.058-.723.32-.976l1.96-1.891-2.708-.39c-.363-.052-.676-.278-.838-.603L8 3.6 6.789 6.03c-.162.325-.475.55-.838.603l-2.708.39 1.96 1.891c.262.253.382.618.32.976l-.463 2.67 2.422-1.26z"
        clip-rule="evenodd"
      />
    </svg>
  );
};

export default Star;
